import { UserProfileState } from '@/redux/modal/UserProfile/userProfile.types';

export const openDetailsReducer = (state: UserProfileState): void => {
  state.activeTab = 0;
};

export const openAuthTokensReducer = (state: UserProfileState): void => {
  state.activeTab = 1;
};
